// navbar.js - Header dropdowns and mobile responsiveness controls

export function initNavbar() {
  const nav = document.getElementById('main-nav');
  if (!nav) return;

  /* Scroll: shadow + hide-on-down / reveal-on-up */
  let lastScrollY = window.scrollY;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    nav.classList.toggle('scrolled', y > 8);
    if (y < 80) {
      nav.classList.remove('nav-hidden');
    } else if (y > lastScrollY + 4) {
      nav.classList.add('nav-hidden');
    } else if (y < lastScrollY - 4) {
      nav.classList.remove('nav-hidden');
    }
    lastScrollY = y;
  }, { passive: true });

  /* Mobile menu */
  const btn = document.getElementById('mobile-menu-btn');
  const menu = document.getElementById('mobile-menu');
  const iconOpen = document.getElementById('menu-icon-open');
  const iconClose = document.getElementById('menu-icon-close');
  if (btn && menu) {
    btn.addEventListener('click', () => {
      const open = menu.classList.contains('is-open');
      menu.classList.toggle('is-open', !open);
      iconOpen?.classList.toggle('hidden', !open);
      iconClose?.classList.toggle('hidden', open);
      btn.setAttribute('aria-expanded', String(!open));
    });
  }

  /* Desktop dropdowns */
  document.querySelectorAll('[data-dropdown]').forEach(dd => {
    let timer;
    const enter = () => { clearTimeout(timer); dd.classList.add('open'); dd.querySelector('.header__dropdown-panel')?.classList.add('is-open'); };
    const leave = () => { timer = setTimeout(() => { dd.classList.remove('open'); dd.querySelector('.header__dropdown-panel')?.classList.remove('is-open'); }, 120); };
    dd.addEventListener('mouseenter', enter);
    dd.addEventListener('mouseleave', leave);
    dd.querySelector('.header__dropdown-panel')?.addEventListener('mouseenter', enter);
    dd.querySelector('.header__dropdown-panel')?.addEventListener('mouseleave', leave);
    dd.querySelectorAll('a, [role="menuitem"]').forEach(a => a.addEventListener('click', () => { dd.classList.remove('open'); dd.querySelector('.header__dropdown-panel')?.classList.remove('is-open'); }));
  });

  /* Language toggle */
  document.querySelectorAll('.header__lang-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.header__lang-btn').forEach(b => {
        b.classList.remove('header__lang-btn--active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('header__lang-btn--active');
      btn.setAttribute('aria-pressed', 'true');
    });
  });
}
